import { render, staticRenderFns } from "./MultipleFeaturePopup.vue?vue&type=template&id=540487d3"
import script from "./MultipleFeaturePopup.vue?vue&type=script&lang=js"
export * from "./MultipleFeaturePopup.vue?vue&type=script&lang=js"
import style0 from "./MultipleFeaturePopup.vue?vue&type=style&index=0&id=540487d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports